'use client'
import {
  Button as ChakraButton,
  defineStyle,
  defineStyleConfig,
  theme,
} from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { ButtonProps } from './Button.types'

const outline = defineStyle({
  ...theme.components.Button.variants?.outline,
  borderColor: 'gray.300',
})

export const ButtonStyle = defineStyleConfig({
  defaultProps: {
    variant: 'solid',
    colorScheme: 'blue',
  },
  variants: {
    ...theme.components.Button.variants,
    outline,
  },
})

export default forwardRef(function Button(
  props: ButtonProps,
  ref: LegacyRef<HTMLButtonElement>
) {
  return <ChakraButton {...props} ref={ref} translate="no" />
})
